import { SliceCaseReducers } from '@reduxjs/toolkit'
import {
  ApiResponse,
  createDownloadSlice,
  createOperationSlice,
  GenericOperationState,
} from '@repo/core'
import { GlobalPositionResponse } from '@repo/position-types'

export interface GlobalPositionRequestParams {
  currency?: string
  date?: string | null
  interventionType?: string
}

const initialState: GenericOperationState<ApiResponse<GlobalPositionResponse> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: globalPositionActions, reducer: globalPositionReducer } =
  createOperationSlice<
    ApiResponse<GlobalPositionResponse> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<GlobalPositionResponse> | null>>,
    GlobalPositionRequestParams
  >({
    name: '@position/master/list/globalPosition',
    initialState,
    reducers: {},
  })

export const { actions: globalPositionDownloadActions, reducer: globalPositionDownloadReducer } =
  createDownloadSlice<GlobalPositionRequestParams | undefined>(
    '@position/master/list/globalPositionDownload',
  )
